import { call, put, takeLatest } from "@redux-saga/core/effects";
import { ConfigurationApi } from "./ConfigurationApi";
import { ConfigurationConstant } from "./ConfigurationConstant";

function* getConfigurationtable() {
  try {
    yield put({ type: ConfigurationConstant.CONFIGURATION_TABLE_REQUEST });

    const res = yield call(ConfigurationApi.getConfigurationTableApi);


    yield put({
      type: ConfigurationConstant.CONFIGURATION_TABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConfigurationConstant.CONFIGURATION_TABLE_RESPONSE,
      payload: [],
    });
  }
}

function* UpdateConfigurationCancelSaga(payload) {
  try {
    yield put({
      type: ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_REQUEST,
    });

    const res = yield call(
      ConfigurationApi.UpdateConfigurationCancelApi,
      payload
    );


    yield put({
      type: ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_RESPONSE,
      payload: [],
    });
  }
}

export function* registerGlobleConfigurationSaga() {
  yield takeLatest(
    ConfigurationConstant.CONFIGURATION_TABLE_SAGA,
    getConfigurationtable
  );
  yield takeLatest(
    ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_SAGA,
    UpdateConfigurationCancelSaga
  );
}
